import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { Modal } from "react-responsive-modal";
import "../../styles/CustomModal.css";
import "react-responsive-modal/styles.css";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
};

const RiderProgressModal = ({ isVisible, setVisible }: Props) => {
  const [isFailed, setIsFailed] = useState<boolean>(false);
  const [status, setStatus] = useState<number>(3);

  const onCloseModal = () => {
    setVisible(false);
  };

  useEffect(() => {}, []);

  const getStatusComment = () => {
    if (status === 1) return "배달 기사 배정이 완료되었어요";
    else if (status === 2) return "음식을 배달중이에요";
    else if (status === 3) return "배달이 완료되었어요";
    else return "주문 접수가 완료되었어요";
  };

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "riderProgressModalOverlay",
        modal: "riderProgressModal",
      }}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="ic"
        />
      }
      showCloseIcon={true}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <div className="timeWrap">
            <h1 className={`${isFailed && "failed"}`}>00 : 30</h1>
          </div>
          {isFailed ? (
            <>
              <h1>{`배달 대행 접수가 실패했어요\n\다시 요청해주세요`}</h1>
              <button className="failButton">
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_refresh.svg`}
                  alt="check"
                />
                <h2>배달기사 재요청</h2>
              </button>
            </>
          ) : (
            <>
              <h1>{getStatusComment()}</h1>
              <div className="statusBarWrap">
                {/* 주문확인 */}
                <div className={`statusDot ${status >= 0 && "active"}`}>
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check.svg`}
                    alt="check"
                  />
                </div>
                <div className={`statusBar ${status >= 1 && "active"}`} />
                {/* 조리중 */}
                <div className={`statusDot ${status >= 1 && "active"}`}>
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check.svg`}
                    alt="check"
                  />
                </div>
                <div className={`statusBar ${status >= 2 && "active"}`} />
                {/* 배달중 */}
                <div className={`statusDot ${status >= 2 && "active"}`}>
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check.svg`}
                    alt="check"
                  />
                </div>
                <div className={`statusBar ${status >= 3 && "active"}`} />
                {/* 배달완료 */}
                <div className={`statusDot ${status >= 3 && "active"}`}>
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check.svg`}
                    alt="check"
                  />
                </div>
              </div>
              <div className="maxWidth">
                <div className="statusTextWrap">
                  <div className="statusText">
                    <h4>{`주문접수\n기사요청중`}</h4>
                  </div>
                  <div className="statusText">
                    <h4>배정완료</h4>
                  </div>
                  <div className="statusText">
                    <h4>{`픽업\n배달중`}</h4>
                  </div>
                  <div className="statusText">
                    <h4>배달완료</h4>
                  </div>
                </div>
                <div className="statusTextWrap">
                  <div className="statusText">
                    <p>11:00</p>
                  </div>
                  <div className="statusText">
                    <p>11:10</p>
                  </div>
                  <div className="statusText">
                    <p>11:20</p>
                  </div>
                  <div className="statusText">
                    <p>11:30</p>
                  </div>
                </div>
              </div>
              <div className="modalFooter">
                <h4>{`김노크\b\b010-1234-1234`}</h4>
                <p>4000원</p>
                <p>1.2km</p>
              </div>
            </>
          )}
        </div>
      </Style>
    </Modal>
  );
};

export default RiderProgressModal;

const Style = styled.div`
  .modal {
    height: 50vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 5% 4% 0 4%;
  }

  h1 {
    font-size: 28px;
    line-height: 34px;
    color: #333333;
    font-weight: 500;
    text-align: center;
  }

  .timeWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f7f7f7;
    border-radius: 50px;
    padding: 2% 6%;
    h1 {
      font-size: 44px;
      line-height: 48px;
      color: #4dd2ae;
      font-weight: 500;
    }
    h1.failed {
      color: #333333;
    }
  }
  .statusBarWrap {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 4% 8% 0 8%;
    justify-content: space-between;
    .statusBar {
      width: calc((100% - 114px) / 3);
      height: 12px;
      margin: 0 -1px;
      background: #f0f0f0;
      z-index: 1;
    }
    .statusBar.active {
      background: #4dd2ae;
    }
    .statusDot {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px !important;
      height: 30px;
      border-radius: 100px;
      background: #ffffff;
      border: 3px solid #4dd2ae;
      z-index: 2;
    }
    .statusDot.active {
      background: #4dd2ae;
    }
  }
  .maxWidth {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .statusTextWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 10px);
    height: 100%;
    text-align: center;

    .statusText {
      width: 20%;
      h4 {
        font-size: 16px;
        line-height: 20px;
        color: #333333;
        font-weight: 500;
      }
      p {
        padding-top: 4px;
        font-size: 14px;
        color: #a7a7a7;
      }
    }
  }

  .failButton {
    padding: 2% 8%;
    border-radius: 10px;
    display: flex;
    align-items: center;
    gap: 14px;
    background: #ff3542;
    border: none;
    margin-bottom: 10%;

    h2 {
      font-size: 32px;
      line-height: 38px;
      font-weight: 600;
      color: #ffffff;
    }
  }

  .modalFooter {
    width: 100%;
    border-top: 1px solid #e6e6e6;
    padding: 3% 4%;
    display: flex;
    align-items: center;
    justify-content: center;

    h4 {
      color: #333333;
      font-weight: 500;
      padding: 2px 14px 2px 0;
      border-right: 1px solid #d9d9d9;
    }
    p {
      padding: 2px 0 2px 14px;
      font-size: 12px;
      color: #a7a7a7;
    }
  }
`;
